import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { ServiceEvents } from '../shared/interfaces';
import { buildEndpoint } from '../EndPoints';

export interface Stage {
    id: number;
    title: string;
    description: string;
    status: 'completed' | 'pending' | 'current';
    stage_number: number;
    blocked_reason?: string | null;  // Motivo por el que la etapa está bloqueada
    url?: string | null;  // URL para navegar a la etapa (si está disponible)
    required_permission?: string | null;  // Permiso requerido para editar
    can_edit?: boolean;  // Si el usuario actual puede editar esta etapa
    can_sign?: boolean;  // Si el usuario actual puede firmar documentos en esta etapa
    can_confirm?: boolean;  // Si el usuario actual puede confirmar esta etapa
}

export interface SummaryData {
    id: number;
    application_number: string;
    brand_name?: string;
    service_type: string;
    assigned_lawyer: string;
    status: string;
    verification_id?: number | null;
    verification_payment_status?: string | null;  // Estado de pago de la verificación: 'pending', 'paid', etc.
    is_applicant?: boolean;  // Indica si el usuario actual es el solicitante
    payment_url?: string | null;  // URL de pago (la misma que se envía en el correo)
    payment_managed_by_firm?: boolean;  // Caso de un estudio: el pago lo acuerda el estudio con su cliente
    inapi_application_id?: number | null;
    inapi_application_number?: string | null;  // Número de solicitud INAPI registrado en la Etapa 3
    formal_examination_id?: number | null;
    official_publication_id?: number | null;
    substantive_examination_id?: number | null;
    definitive_resolution_id?: number | null;
    is_completed?: boolean;  // Marca registrada
    monitoring_enabled?: boolean;  // Seguimiento en el Diario Oficial
    can_manage_monitoring?: boolean;
    pending_alerts?: number;
}

export interface StagesData {
    summary: SummaryData;
    stages: Stage[];
    total_stages: number;
    completed_stages: number;
    current_stage: number | null;
    progress_percentage: number;
}

export interface GetStagesParams {
    brand_registration_id: number;
}

const useBrandRegistrationStagesService = () => {
    const { doGet } = useFetch();
    const [fetchingGetBrandRegistrationStages, setFetchingGetBrandRegistrationStages] = useState(false);

    const BASE_PATH = 'brand-registrations/brand-registrations';

    const getBrandRegistrationStages = (brand_registration_id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${brand_registration_id}/stages`),
            setFetching: setFetchingGetBrandRegistrationStages
        });
    };

    return {
        fetchingGetBrandRegistrationStages,
        getBrandRegistrationStages
    };
};

export default useBrandRegistrationStagesService;
